export enum KeyName {
  ESCAPE = 'Escape',
  ENTER = 'Enter',
  TAB = 'Tab',
  ALT = 'Alt'
}
